export default class Header {
    constructor() {
        this.html = document.querySelector('html');
        this.header = document.querySelector('header');
        this.buttonMenu = document.querySelector('#responsiveButton');
        this.menu = document.querySelector('.menu-full');
        this.closeMenu = document.querySelector('#close-menu');

        this.btnArrowUp = document.querySelector('.btn-footer-arrow-up');

        this.menuFixed = document.querySelector('.menu-fixo');
        this.linkHome = document.querySelector('#home');
        this.linkProducts = document.querySelector('#products');
        this.linkProteins = document.querySelector('#proteins');
        this.linkContents = document.querySelector('#contents');
        this.linkContact = document.querySelector('#contact');
        this.linkBuy = document.querySelector('#buy');
        this.linkEvents = document.querySelector('#events');

        this.linkHomeMobile = document.querySelector('#homeMobile');
        this.linkProductsMobile = document.querySelector('#productsMobile');
        this.linkProteinsMobile = document.querySelector('#proteinsMobile');
        this.linkContentsMobile = document.querySelector('#contentsMobile');
        this.linkContactMobile = document.querySelector('#contactMobile');
        this.linkBuyMobile = document.querySelector('#buyMobile');
        this.linkEventsMobile = document.querySelector('#eventsMobile');

        this.links = document.querySelectorAll('.menu-item');

        this.urlPathname = window.location.pathname;

        this.ready();
    }

    ready() {
        this.buttonMenu.addEventListener('click', () => {
            this.menu.classList.add('active');
            this.html.classList.add('noScroll');
        });

        this.closeMenu.addEventListener('click', () => {
            this.html.classList.remove('noScroll');
            this.menu.classList.remove('active');
        });

        if (this.btnArrowUp) {
            this.btnArrowUp.addEventListener('click', () => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        }

        window.onscroll = () => {
            this.menuFixed.classList.toggle('top-0', window.scrollY > 0);
        };

        this.links.forEach((l) => l.classList.remove('active'));

        const urlToElementMap = {
            'produtos': this.linkProducts,
            'calculadora-de-proteinas': this.linkProteins,
            'conteudos': this.linkContents,
            'fale-conosco': this.linkContact,
            'compre-agora': this.linkBuy,
            'eventos': this.linkEvents,
        };

        const urlToElementMapMobile = {
            'produtos': this.linkProductsMobile,
            'calculadora-de-proteinas': this.linkProteinsMobile,
            'conteudos': this.linkContentsMobile,
            'fale-conosco': this.linkContactMobile,
            'compre-agora': this.linkBuyMobile,
            'eventos': this.linkEventsMobile,
        };

        const currentPath = this.urlPathname;

        const activateElements = (map) => {
            for (const url in map) {
                if (currentPath.indexOf(url) > -1) {
                    console.log(map[url]);
                    map[url].classList.add('active');
                }
            }
        };        
        
        if (this.urlPathname === '/') {
            this.linkHome.classList.add('active');
            this.linkHomeMobile.classList.add('active');
        }

        activateElements(urlToElementMap);
        activateElements(urlToElementMapMobile);
    }
}
document.querySelector('header') ? new Header() : null;
